import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesLeft, faAnglesRight, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";



function TablePagination({pagination, setPagination, pageSizes}) {


  return (
    <div className="d-flex justify-content-between py-1 w-100">
        <div className="d-flex gap-0 ">
        <select
            value={pagination.page_size}
            onChange={(e) =>
            setPagination({
                ...pagination,
                page_size: Number(e.target.value),
                page: 1,
            })
            }
            className="page-sizer Nunito"
        >
            {pageSizes.map((pageSize, index) => {
            return (
                <option key={index} value={pageSize}>
                {pageSize}
                </option>
            );
            })}
        </select>
        {pagination.begin_of_page &&
        pagination.end_of_page &&
        pagination.max_items ? (
            <div className="page-display text-nowrap me-4 Nunito">
            {pagination.begin_of_page}-{pagination.end_of_page} van {pagination.max_items}
            </div>
        ) : null}
        </div>
        <div className="d-flex gap-1">
        <button
            onClick={(e) => setPagination({ ...pagination, page: 1 })}
            disabled={pagination.page === 1}
            type="button"
            className="btn rounded-2 border-0 px-1 text-nowrap toFirstLastPage"
        >
            <FontAwesomeIcon className="text-white" icon={faAnglesLeft} />
        </button>
        <button
            onClick={(e) =>
            setPagination({ ...pagination, page: pagination.page - 1 })
            }
            disabled={pagination.page <= 1}
            type="button"
            className="btn rounded-2 border-0 pageBackNext"
        >
            <FontAwesomeIcon className="text-white" icon={faChevronLeft} />
        </button>
        <button
            onClick={(e) =>
            setPagination({ ...pagination, page: pagination.page - 1 })
            }
            hidden={pagination.page <= 1}
            type="button"
            className="btn rounded-2 border-0 bg-white text-center pageNumBlocks Nunito"
            style={{
            fontWeight: "600",
            color: "#009fe3",
            width: "30px",
            height: "30px",
            }}
        >
            {pagination.page - 1}
        </button>
        <button
            type="button"
            className="btn rounded-2 border-0 text-white text-center pageNumBlocks Nunito"
            disabled
            style={{
            fontWeight: "600",
            backgroundColor: "#007eb4ff",
            cursor: "default",
            width: "30px",
            height: "30px",
            opacity: "1",
            }}
        >
            {pagination.page}
        </button>
        <button
            onClick={(e) =>
            setPagination({ ...pagination, page: pagination.page + 1 })
            }
            hidden={
            Math.ceil(pagination.max_items / pagination.page_size) <= pagination.page
            }
            type="button"
            className="btn rounded-2 border-0 bg-white text-center pageNumBlocks Nunito"
            style={{
            fontWeight: "600",
            color: "#009fe3",
            width: "30px",
            height: "30px",
            }}
        >
            {pagination.page + 1}
        </button>
        <button
            onClick={(e) =>
            setPagination({ ...pagination, page: pagination.page + 1 })
            }
            disabled={
            Math.ceil(pagination.max_items / pagination.page_size) === pagination.page ||
            pagination.max_items <= 0
            }
            type="button"
            className="btn rounded-2 border-0 pageBackNext"
        >
            <FontAwesomeIcon className="text-white" icon={faChevronRight} />
        </button>
        <button
            onClick={(e) =>
            Math.ceil(pagination.max_items / pagination.page_size) === 0
                ? setPagination({ ...pagination, page: 1 })
                : setPagination({
                    ...pagination,
                    page: Math.ceil(pagination.max_items / pagination.page_size),
                })
            }
            disabled={
            Math.ceil(pagination.max_items / pagination.page_size) === pagination.page ||
            pagination.max_items <= 0
            }
            type="button"
            className="btn rounded-2 border-0 text-nowrap px-1 toFirstLastPage"
        >
            <FontAwesomeIcon className="text-white" icon={faAnglesRight} />
        </button>
        </div>
    </div>
  );
}

export default TablePagination;
